export default __webpack_public_path__ + "static/media/vip1.5cf77027.webp";